import Panel from 'components/Panel';
import i18n from 'i18n';
import {isArray, isEmpty, map} from 'lodash';
import React from 'react';
import {IErrorItem, IErrorMessage, ITransactionErrorItem} from 'types/diplomat/ErrorItem';

const formatBlock = (name: string, messages: ITransactionErrorItem) => {
   return (
      <Panel name={name}>
         {map(messages, (errors: string[] | {message: string}, name: string) => (
            <Panel name={name}>
               {isArray(errors) ? errors.map((e) => <div key={e}>{e}</div>) : errors.message}
            </Panel>
         ))}
      </Panel>
   );
};

export function getTransactionErrorMessages(
   errorBody: {errors: ITransactionErrorItem; warnings: ITransactionErrorItem},
   altMessage?: string
) {
   const errors = errorBody?.errors ? formatBlock(i18n.t('Errors'), errorBody.errors) : altMessage;

   const warnings = errorBody?.warnings ? formatBlock(i18n.t('Warnings'), errorBody.warnings) : '';

   return (
      <>
         {errors}
         {warnings}
      </>
   );
}
